import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { GachaModalService } from '../../services/gacha-modal.service';
import { MobileScaleService } from '../../services/mobile-scale.service';
import { Wallet } from '../../services/wallet';
import { GachaRollComponent } from '../gacha-roll/gacha-roll.component';
import { PixelCreatureComponent } from '../pixel-creature/pixel-creature.component';

@Component({
  selector: 'app-nav-bar',
  imports: [GachaRollComponent, PixelCreatureComponent],
  templateUrl: './nav-bar.component.html',
  styleUrls: [
    './nav-bar.component.css',
    './nav-bar.component.mobile.css',
  ],
  host: { '(document:keydown.escape)': 'onEscapeKey()' },
})
export class NavBarComponent {
  private readonly router = inject(Router);
  readonly mobile = inject(MobileScaleService);
  readonly wallet = inject(Wallet);
  readonly gachaModal = inject(GachaModalService);

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(() => this.router.url),
    ),
    { initialValue: this.router.url },
  );

  /** Mobile battle is a full-screen experience — the nav-bar gets out of the way. Desktop battle keeps the header nav. */
  readonly hidden = computed(() => this.mobile.isMobile && this.currentUrl().startsWith('/battle'));

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  isCurrentRoute(route: string): boolean {
    return this.currentUrl() === route;
  }

  isSectionActive(prefix: string): boolean {
    const url = this.currentUrl();
    return url === prefix || url.startsWith(prefix + '/');
  }

  openGachaModal() {
    this.gachaModal.open();
  }

  closeGachaModal() {
    this.gachaModal.close();
  }

  onEscapeKey() {
    if (this.gachaModal.showModal()) {
      this.closeGachaModal();
    }
  }
}
